import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _iconMap;

import _regeneratorRuntime from "/builds/everlywell/apps/www/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import React, { useEffect, useState } from "react";
import { config, useSpring } from "react-spring";
import { generateKey, handleAccessibleKeyPress } from "../../shared/utils";
import { Error, InfoV2, Success, Warning } from "../Icons";
import * as S from "./styles";
export var ToastType;
!function (e) {
  e.INFO = "info", e.SUCCESS = "success", e.WARNING = "warning", e.ERROR = "error";
}(ToastType || (ToastType = {}));
var iconMap = (_iconMap = {}, _defineProperty(_iconMap, ToastType.INFO, React.createElement(InfoV2, {
  "data-testid": "info-icon"
})), _defineProperty(_iconMap, ToastType.SUCCESS, React.createElement(Success, {
  "data-testid": "success-icon"
})), _defineProperty(_iconMap, ToastType.ERROR, React.createElement(Error, {
  "data-testid": "error-icon"
})), _defineProperty(_iconMap, ToastType.WARNING, React.createElement(Warning, {
  "data-testid": "warning-icon"
})), _iconMap);
export var Toast = function Toast(_ref) {
  var e = _ref.type,
      t = _ref.handleClose,
      a = _ref.content,
      o = _ref.subtext,
      n = _ref.className,
      _ref$persistent = _ref.persistent,
      s = _ref$persistent === void 0 ? !1 : _ref$persistent,
      _ref$animationSpeed = _ref.animationSpeed,
      r = _ref$animationSpeed === void 0 ? "slow" : _ref$animationSpeed,
      _ref$visibleTime = _ref.visibleTime,
      i = _ref$visibleTime === void 0 ? 5e3 : _ref$visibleTime,
      _ref$uid = _ref.uid,
      c = _ref$uid === void 0 ? generateKey() : _ref$uid;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      l = _useState2[0],
      p = _useState2[1],
      m = "normal" === r ? config.default : "fast" === r ? config.stiff : config.slow,
      d = useSpring({
    to: function to(e) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!l) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return e({
                  display: "flex"
                });

              case 3:
                _context.next = 5;
                return e({
                  opacity: 1
                });

              case 5:
                _context.next = 11;
                break;

              case 7:
                _context.next = 9;
                return e({
                  opacity: 0
                });

              case 9:
                _context.next = 11;
                return e({
                  display: "none"
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    from: {
      opacity: 0,
      display: "none"
    },
    config: m
  });

  return useEffect(function () {
    p(!0);
    var e = setTimeout(function () {
      s || p(!1);
    }, i);
    return function () {
      return clearTimeout(e);
    };
  }, [s, i]), React.createElement(S.Wrapper, {
    type: e,
    className: n,
    "data-testid": "toast-".concat(e, "-").concat(c),
    style: d,
    visibleTime: i
  }, React.createElement(S.WrapperLimit, null, React.createElement(S.IconWrapper, null, iconMap[e]), React.createElement(S.ContentWrapper, null, React.createElement(S.Content, null, a), React.createElement(S.Subtext, null, o))), React.createElement(S.CloseWrapper, {
    "data-testid": "toast-".concat(e, "-").concat(c, "-closeButton"),
    role: "button",
    tabIndex: "0",
    id: "".concat(e, "CloseButton"),
    "aria-label": "Close Notification",
    onKeyPress: function onKeyPress(e) {
      return handleAccessibleKeyPress(e, t);
    },
    onClick: function onClick() {
      return t();
    }
  }, React.createElement(S.CloseIcon, null)));
};
export default Toast;